"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = __importStar(require("react"));
var PDFReportService_1 = __importDefault(require("../../../Trillium.UI/TypeScript/Services/Reports/PDFReportService"));
var userRoleList = {
    Trainee: "Role - Trainee",
    Mentor: "Role - Mentor",
    DelegateEngineer: "Role - Delegated Engineer",
    SupervisingCivilEngineer: "Role - Supervising Civil Engineer",
    TrainingProviderAdministrator: "Role - Training Provider Administrator",
    TrainingSchemeAdministrator: "Role - Training Scheme Administrator",
    MDO: "Role - Membership Development Officer",
    ICE: "Role - ICE contact"
};
var PageList = {
    Summary: 'SummaryPage',
    Attributes: 'AttributesPage',
    AttributeDetails: 'AttributeDetailsPage',
    IndividualAnnualAppraisal: 'IndividualAnnualAppraisalPage',
    MyDetails: 'MyDetailsPage',
    YourPerticularTraineePage: 'YourPerticularTraineePage',
    Trainees: 'TraineesPage',
    SupervisoryTraineeIndividualAttribute: 'SupervisoryTraineeIndividualAttribute',
    PerticularTraineeCompletion: 'PerticularTraineeCompletionPage',
    PerticularPartialTraineeCompletion: 'PerticularTraineePartialCompletionPage',
    SuppervisoryIndividualAppraisal: 'SuppervisoryIndividualAppraisal',
    TsaIndividualTrainee: 'TsaIndividualTraineePage',
    TsaTraineeEvidence: 'TsaTraineeEvidencePage',
    MDOAttributeList: "MDOAttributeListPage",
    TrainingAgreements: "TrainingAgreementsPage",
    MDOTraineeEvidence: "MDOTraineeEvidencePage"
};
var downloadtype = {
    Attributes: 'Attributes',
    IndividualAttributeReport: 'IndividualAttributeReport',
    IndividualAnnualAppraisalReport: 'IndividualAnnualAppraisalReport',
    AllAttributesEvidenceReport: 'AllAttributesEvidenceReport',
    AnnualAppraisalsReport: 'AnnualAppraisals',
    AllAttributesAppraisalsCompletions: 'AllAttributesAppraisalsCompletions',
    CompletionReports: 'CompletionReports',
    PartialCompletionReports: 'PartialCompletionReports'
};
var pdfService = new PDFReportService_1.default();
var DownloadPdfReportComponent = function (props) {
    var TrainingAgreement = props.TrainingAgreement, Admin = props.Admin, CurrentUserIPDRole = props.CurrentUserIPDRole;
    var _a = react_1.useState({ open: false, selectedType: '' }), modelDetails = _a[0], setModelDetails = _a[1];
    var _b = react_1.useState([]), downloadTypes = _b[0], setDownloadTypes = _b[1];
    var _c = react_1.useState(false), loader = _c[0], setLoader = _c[1];
    var _d = react_1.useState(''), currentPage = _d[0], setCurrentPage = _d[1];
    var _e = react_1.useState(''), contactId = _e[0], setContactId = _e[1];
    var _f = react_1.useState(''), attributeId = _f[0], setAttributeId = _f[1];
    var _g = react_1.useState(''), appraisalId = _g[0], setAppraisalId = _g[1];
    var _h = react_1.useState(""), errorMessage = _h[0], setErrorMessage = _h[1];
    var _j = react_1.useState(''), trainingAgreementId = _j[0], setTrainingAgreementId = _j[1];
    var handleChangeValue = react_1.useCallback(function (event) {
        setCurrentPage(event.target.value);
    }, []);
    react_1.useEffect(function () {
        var contactElement = document.getElementById('contactId');
        if (contactElement) {
            setContactId(contactElement.value);
        }
        if (props.contactId) {
            setContactId(props.contactId);
        }
        if (props.trainingAgreementId) {
            setTrainingAgreementId(props.trainingAgreementId);
        }
        var attributeElement = document.getElementById('attributeId');
        if (attributeElement) {
            setAttributeId(attributeElement.value ? attributeElement.value : '');
        }
        var appraisalElement = document.getElementById('appraisalId');
        if (appraisalElement) {
            setAppraisalId(appraisalElement.value);
        }
        var TrainingAgreementElement = document.getElementById('TrainingAgreementId');
        if (TrainingAgreementElement) {
            setTrainingAgreementId(TrainingAgreementElement.value);
        }
        if (TrainingAgreement) {
            setTrainingAgreementId(TrainingAgreement === null || TrainingAgreement === void 0 ? void 0 : TrainingAgreement.Id);
        }
        var currentPageInput = document.getElementById('CurrentPage');
        if (currentPageInput) {
            currentPageInput.addEventListener('change', handleChangeValue);
        }
        if (props.TrainingAgreement && props.TrainingAgreement.Contact.Id) {
            setContactId(props.TrainingAgreement.Contact.Id);
        }
        var recordTypeList = [];
        var Trainee = userRoleList.Trainee, SupervisingCivilEngineer = userRoleList.SupervisingCivilEngineer, DelegateEngineer = userRoleList.DelegateEngineer, Mentor = userRoleList.Mentor, TrainingProviderAdministrator = userRoleList.TrainingProviderAdministrator, TrainingSchemeAdministrator = userRoleList.TrainingSchemeAdministrator, MDO = userRoleList.MDO, ICE = userRoleList.ICE;
        var Summary = PageList.Summary, Attributes = PageList.Attributes, AttributeDetails = PageList.AttributeDetails, IndividualAnnualAppraisal = PageList.IndividualAnnualAppraisal, SuppervisoryIndividualAppraisal = PageList.SuppervisoryIndividualAppraisal, MDOTraineeEvidence = PageList.MDOTraineeEvidence, YourPerticularTraineePage = PageList.YourPerticularTraineePage, TrainingAgreements = PageList.TrainingAgreements, PerticularTraineeCompletion = PageList.PerticularTraineeCompletion, PerticularPartialTraineeCompletion = PageList.PerticularPartialTraineeCompletion, TsaTraineeEvidence = PageList.TsaTraineeEvidence, MDOAttributeList = PageList.MDOAttributeList, SupervisoryTraineeIndividualAttribute = PageList.SupervisoryTraineeIndividualAttribute, TsaIndividualTrainee = PageList.TsaIndividualTrainee;
        if ([Trainee].includes(props.CurrentUserIPDRole)) {
            setContactId(props.TrainingAgreement.Contact.Id);
        }
        if ([Trainee, DelegateEngineer, Mentor, SupervisingCivilEngineer, MDO, ICE].includes(props.CurrentUserIPDRole)) {
            if ([Summary, YourPerticularTraineePage, MDOAttributeList].includes(currentPage)) {
                recordTypeList.push({ value: "Attributes", label: "Attributes" });
                recordTypeList.push({ value: "AnnualAppraisals", label: "Annual appraisals" });
                recordTypeList.push({ value: "CompletionReports", label: "Completion reports" });
                recordTypeList.push({ value: "AllAttributesAppraisalsCompletions", label: "All attributes, appraisals and completions" });
            }
            if ([Attributes].includes(currentPage)) {
                recordTypeList.push({ value: "AllAttributesEvidenceReport", label: "All attributes and evidence report" });
            }
            if ([PerticularTraineeCompletion].includes(currentPage)) {
                recordTypeList.push({ value: "CompletionReports", label: "Completion reports" });
            }
            if ([PerticularPartialTraineeCompletion].includes(currentPage)) {
                recordTypeList.push({ value: "PartialCompletionReports", label: "Completion reports" });
            }
            if ([AttributeDetails, SupervisoryTraineeIndividualAttribute].includes(currentPage)) {
                if ([Trainee, DelegateEngineer, Mentor, SupervisingCivilEngineer, TrainingSchemeAdministrator, MDO, ICE].includes(props.CurrentUserIPDRole)) {
                    recordTypeList.push({ value: "AllAttributesEvidenceReport", label: "All attributes and evidence report" });
                    recordTypeList.push({ value: "IndividualAttributeReport", label: "Individual attribute report" });
                }
            }
            if ([IndividualAnnualAppraisal, SuppervisoryIndividualAppraisal].includes(currentPage)) {
                if (appraisalElement && appraisalElement.value)
                    recordTypeList.push({ value: "IndividualAnnualAppraisalReport", label: "Individual annual appraisal report" });
            }
        }
        if ([TrainingSchemeAdministrator, MDO, ICE].includes(props.CurrentUserIPDRole)) {
            if ([TsaTraineeEvidence, MDOTraineeEvidence].includes(currentPage)) {
                recordTypeList.push({ value: "Attributes", label: "Attributes" });
                recordTypeList.push({ value: "AnnualAppraisals", label: "Annual appraisals" });
                recordTypeList.push({ value: "CompletionReports", label: "Completion reports" });
                recordTypeList.push({ value: "AllAttributesAppraisalsCompletions", label: "All attributes, appraisals and completions" });
            }
            if ([IndividualAnnualAppraisal].includes(currentPage)) {
                recordTypeList.push({ value: "IndividualAnnualAppraisalReport", label: "Individual annual appraisal report" });
            }
        }
        if ([TrainingAgreements].includes(props.currentPage)) {
            recordTypeList.push({ value: "Attributes", label: "Attributes" });
            recordTypeList.push({ value: "AnnualAppraisals", label: "Annual appraisals" });
            recordTypeList.push({ value: "CompletionReports", label: "Completion reports" });
            recordTypeList.push({ value: "AllAttributesAppraisalsCompletions", label: "All attributes, appraisals and completions" });
        }
        setDownloadTypes(recordTypeList);
        return function () {
            window.removeEventListener("change", handleChangeValue);
        };
    }, [currentPage]);
    var openModel = function () {
        setModelDetails(__assign(__assign({}, modelDetails), { open: true }));
    };
    var closeModel = function () {
        setLoader(false);
        setErrorMessage("");
        setModelDetails(__assign(__assign({}, modelDetails), { open: false, selectedType: '' }));
    };
    var onTypeChange = function (value) {
        setModelDetails(__assign(__assign({}, modelDetails), { selectedType: value }));
    };
    var Attributes = downloadtype.Attributes, IndividualAttributeReport = downloadtype.IndividualAttributeReport, IndividualAnnualAppraisalReport = downloadtype.IndividualAnnualAppraisalReport, AllAttributesEvidenceReport = downloadtype.AllAttributesEvidenceReport, AnnualAppraisalsReport = downloadtype.AnnualAppraisalsReport, AllAttributesAppraisalsCompletions = downloadtype.AllAttributesAppraisalsCompletions, CompletionReports = downloadtype.CompletionReports, PartialCompletionReports = downloadtype.PartialCompletionReports;
    var onExportReport = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, contentDisposition, fileName, blob, link;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (![Attributes, AllAttributesEvidenceReport].includes(modelDetails.selectedType)) return [3 /*break*/, 4];
                    if (!trainingAgreementId) return [3 /*break*/, 2];
                    setLoader(true);
                    return [4 /*yield*/, pdfService.getAttributesReport(contactId, CurrentUserIPDRole, setLoader, trainingAgreementId)];
                case 1:
                    response = _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    if (!contactId) return [3 /*break*/, 4];
                    setLoader(true);
                    return [4 /*yield*/, pdfService.getAttributesReport(contactId, CurrentUserIPDRole, setLoader)];
                case 3:
                    response = _a.sent();
                    _a.label = 4;
                case 4:
                    if (![IndividualAttributeReport].includes(modelDetails.selectedType)) return [3 /*break*/, 8];
                    if (!attributeId) return [3 /*break*/, 8];
                    if (!trainingAgreementId) return [3 /*break*/, 6];
                    setLoader(true);
                    return [4 /*yield*/, pdfService.getAttributeReport(contactId, attributeId, CurrentUserIPDRole, setLoader, trainingAgreementId)];
                case 5:
                    response = _a.sent();
                    return [3 /*break*/, 8];
                case 6:
                    setLoader(true);
                    return [4 /*yield*/, pdfService.getAttributeReport(contactId, attributeId, CurrentUserIPDRole, setLoader)];
                case 7:
                    response = _a.sent();
                    _a.label = 8;
                case 8:
                    if (![IndividualAnnualAppraisalReport].includes(modelDetails.selectedType)) return [3 /*break*/, 12];
                    if (!(contactId && appraisalId)) return [3 /*break*/, 12];
                    if (!trainingAgreementId) return [3 /*break*/, 10];
                    setLoader(true);
                    return [4 /*yield*/, pdfService.getAppraisalReport(contactId, appraisalId, setLoader, trainingAgreementId)];
                case 9:
                    response = _a.sent();
                    return [3 /*break*/, 12];
                case 10:
                    setLoader(true);
                    return [4 /*yield*/, pdfService.getAppraisalReport(contactId, appraisalId, setLoader)];
                case 11:
                    response = _a.sent();
                    _a.label = 12;
                case 12:
                    if (![AnnualAppraisalsReport].includes(modelDetails.selectedType)) return [3 /*break*/, 16];
                    if (!trainingAgreementId) return [3 /*break*/, 14];
                    setLoader(true);
                    return [4 /*yield*/, pdfService.getAppraisalsReport(contactId, setLoader, trainingAgreementId)];
                case 13:
                    response = _a.sent();
                    return [3 /*break*/, 16];
                case 14:
                    if (!contactId) return [3 /*break*/, 16];
                    setLoader(true);
                    return [4 /*yield*/, pdfService.getAppraisalsReport(contactId, setLoader)];
                case 15:
                    response = _a.sent();
                    _a.label = 16;
                case 16:
                    if (![AllAttributesAppraisalsCompletions].includes(modelDetails.selectedType)) return [3 /*break*/, 20];
                    if (!trainingAgreementId) return [3 /*break*/, 18];
                    setLoader(true);
                    return [4 /*yield*/, pdfService.getAllAttributesAppraisalsAndCompletionsReport(contactId, CurrentUserIPDRole, setLoader, trainingAgreementId)];
                case 17:
                    response = _a.sent();
                    return [3 /*break*/, 20];
                case 18:
                    if (!contactId) return [3 /*break*/, 20];
                    setLoader(true);
                    return [4 /*yield*/, pdfService.getAllAttributesAppraisalsAndCompletionsReport(contactId, CurrentUserIPDRole, setLoader)];
                case 19:
                    response = _a.sent();
                    _a.label = 20;
                case 20:
                    if (![CompletionReports].includes(modelDetails.selectedType)) return [3 /*break*/, 22];
                    if (!(contactId && trainingAgreementId)) return [3 /*break*/, 22];
                    setLoader(true);
                    return [4 /*yield*/, pdfService.getFullCompletionReport(contactId, trainingAgreementId, setLoader)];
                case 21:
                    response = _a.sent();
                    _a.label = 22;
                case 22:
                    if (![PartialCompletionReports].includes(modelDetails.selectedType)) return [3 /*break*/, 24];
                    if (!(contactId && trainingAgreementId)) return [3 /*break*/, 24];
                    setLoader(true);
                    return [4 /*yield*/, pdfService.GetPartialCompletionReport(contactId, trainingAgreementId, setLoader)];
                case 23:
                    response = _a.sent();
                    _a.label = 24;
                case 24:
                    if (response) {
                        if (response && response.data && response.data.size === 0) {
                            if ([AnnualAppraisalsReport, IndividualAnnualAppraisalReport].includes(modelDetails.selectedType)) {
                                setErrorMessage("No Annual Appraisals available to download.");
                            }
                            if ([CompletionReports, PartialCompletionReports].includes(modelDetails.selectedType)) {
                                setErrorMessage("No Completions available to download.");
                            }
                            setLoader(false);
                            return [2 /*return*/];
                        }
                        console.log("this is the response of the get PDF Report", response);
                        contentDisposition = response.headers['content-disposition'];
                        fileName = void 0;
                        if (contentDisposition) {
                            fileName = contentDisposition.replace("attachment; filename=", "");
                        }
                        else {
                            console.warn("Content Disposition was not provided in the headers");
                        }
                        blob = new Blob([response.data], { type: 'application/pdf' });
                        link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        link.click();
                        closeModel();
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    if (contactId != '' && downloadTypes.length > 0) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("button", { type: "button", className: "px-0 btn btn-primary btn-sm btn-block", style: { minWidth: "150px" }, onClick: openModel }, "Download a report"),
            modelDetails.open ? react_1.default.createElement(core_1.Dialog, { onClose: closeModel, "aria-labelledby": "simple-dialog-title", open: modelDetails.open, className: 'ipd-portal ipd-dialog-file-uploader', maxWidth: 'lg' },
                react_1.default.createElement(core_1.DialogTitle, { id: "simple-dialog-title", className: "up-padding" },
                    react_1.default.createElement("p", { style: { fontSize: '20px', color: 'black' } }, "Export report"),
                    react_1.default.createElement("img", { src: '/images/icons/close.svg', className: 'closeIcon cursor-pointer', onClick: closeModel })),
                react_1.default.createElement(core_1.DialogContent, { className: "nopadding" },
                    react_1.default.createElement("h2", null, "Report contents"),
                    react_1.default.createElement(core_1.RadioGroup, { "aria-labelledby": "demo-radio-buttons-group-label", name: "radio-buttons-group", onChange: function (e) { return onTypeChange(e.target.value); }, value: modelDetails.selectedType, className: "up-padding" }, downloadTypes.map(function (o, index) { return react_1.default.createElement(core_1.FormControlLabel, { key: index, value: o.value, control: react_1.default.createElement(core_1.Radio, { disabled: !loader ? false : true, style: { color: "#007C92" } }), label: react_1.default.createElement("div", { className: "group_select" }, o.label) }); })),
                    react_1.default.createElement("div", { className: "report_download_warning" },
                        react_1.default.createElement("span", null, "Large reports may take some time to generate")),
                    errorMessage && (react_1.default.createElement("div", { style: { color: "red", marginTop: "10px", fontWeight: "bold" } }, errorMessage))),
                loader && react_1.default.createElement("div", { className: "spinner-border loading-indicator mb-2" }),
                react_1.default.createElement(core_1.DialogActions, null,
                    react_1.default.createElement(core_1.Button, { onClick: closeModel, className: 'btn btn-primary btn-primary-outline  mr-auto' }, "Cancel"),
                    react_1.default.createElement(core_1.Button, { onClick: onExportReport, className: 'btn btn-primary', disabled: !loader && modelDetails.selectedType ? false : true }, "Download Pdf Report"))) : null));
    }
    else
        return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.default = DownloadPdfReportComponent;
